module.exports = __webpack_public_path__ + "static/media/example-of-file-company-commercial-register.d20f6830.pdf";